module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[3]2.a09a782.woff2";